
export const getNumberFromEvent = (event: any, isInt = true) => {
  const str = event.target.value.toString().replace(/,/g, '');
  const value = isInt ? Number.parseInt(str, 10) : Number.parseFloat(str);

  if (Number.isNaN(value)) {
    return '';
  }

  if (value < 0) {
    return 0;
  }

  return value;
};

export const calculate = (
	filingSatus: string,  // filing status
	dependents: number,  // How many dependents did you claim on your 2020 tax return
	income: number, // the adjusted gross income reported on your 2020 tax return
) => {

  let A;
  switch (filingSatus) {
    case "married-jointly":
      A = 2800;
      break;
    case "head-houshold":
    case "single":
    case "married-separately":
    case "widower":
      A = 1400;
      break;
    default:
      A = 0;
  }

  const B = dependents;
  const C = income;

  let D; // Phase-Out Threshold
  switch (filingSatus) {
    case "married-jointly":
    case "widower":
      D = 150000;
      break;
    case "head-houshold":
      D = 112500;
      break;
    case "single":
    case "married-separately":
      D = 75000;
      break;
    default:
      D = 0;
  }

  let E; // Phase-Out Rate Set Amount
  switch (filingSatus) {
    case "married-jointly":
    case "widower":
      E = 10000;
      break;
    case "head-houshold":
      E = 7500;
      break;
    case "single":
    case "married-separately":
      E = 5000;
      break;
    default:
      E = 1;
  }

  // STEP 1
  const combinedAmount = A + (B * 1400);

  // STEP 2
  const phaseOutRate = (C - D) / E;

  // STEP 3
  const reduction = Math.floor(combinedAmount * phaseOutRate);

  // STEP 4
  const isAGIBelowThreshold = income < D;
  // Math.max(combinedAmount - reduction, 0) <-- reduction can't be more than combined amount
  const monthlyPayment = !isAGIBelowThreshold ? Math.max(combinedAmount - reduction, 0) : combinedAmount;

  return {
    monthlyPayment,
  };
};
